export default __webpack_public_path__ + "list-with-dots.png";